import React, { useState, Fragment, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { AxiosGetJson, AxiosPostJson } from "src/Service/Config/AxiosMethod";
import { localJwtKey } from "src/Service/Config/ApiUrl";
import { makeStyles, Avatar,useMediaQuery  } from "@material-ui/core";
import {
  Sweetalert,
  AlertIcon,
  DialogConfirm,
} from "src/components/Systems/MaterialComponent";
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles((theme) => ({
  buttonInner: {
    display: "flex",
    alignItems: "center",
  },
  text: {
    margin: theme.spacing(0, 0.5, 0, 1),
    display: "none",
    flexDirection: "column",
    alignItems: "flex-start",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}));

const localUserID = "vdsafdwxd31f";


function UserInfo() {
  const classes = useStyles();
  const [User, setUser] = useState([] as any);
  const [dataUser, setdataUser] = useState([] as any)

  const matches = useMediaQuery('(min-width:950px)');


  useEffect(() => {
    GetUserAccount();
    GetDataUser();
  }, []);

  const GetUserAccount = async () => {
    if (localStorage.getItem(localJwtKey) != null) {
      let user_auth: any = await AxiosGetJson("Auth/GetAccount");
      if (user_auth.sUserID != null) {
        setUser(user_auth);
        //Update Expire
        let update_token: any = await AxiosGetJson("Auth/UpdateToken");
        if (update_token.token) {
          localStorage.setItem(localJwtKey, JSON.stringify(update_token.token));

          // let check: any = await AxiosGetJson("Auth/GetAccount");
        }
      }
      else {
        await handleLogOutClick("");
      }
    }
  };

  const GetDataUser = async () => {
    let result = await AxiosGetJson("Home/GetUser");
    if (result) {
      setdataUser(result[0])
    }
  }

  const handleLogOutClick = async (sEvent) => {

    let localUser = localStorage.getItem(localUserID);
    let dataSend = {
      nUserID: localUser,
    };
    if (sEvent == "click") {
      DialogConfirm(
        async () => {
          await AxiosPostJson("Auth/Logout", dataSend);
          localStorage.removeItem(localJwtKey);
          localStorage.removeItem(localUserID);
          setUser([]);
          window.location.href = process.env.REACT_APP_URL + "Login";
        },
        false,
        "",
        "Do you want to log out ?"
      );
    } else {
      await AxiosPostJson("Auth/Logout", dataSend);
      localStorage.removeItem(localJwtKey);
      localStorage.removeItem(localUserID);
      setUser([]);

      Sweetalert.Warning(
        AlertIcon.warning,
        "Session timeout ! Please login again.",
        () => (window.location.href = process.env.REACT_APP_URL + "Login")
      );
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={2} justify={'center'} style={{ marginTop: '10px', width: '210px' }}>
        <Grid item lg={3} md={3} sm={12} xs={12}>
          <Grid container justify={'center'}>
            <Grid item>
              <Avatar style={{ width:  !matches ? '94px' : '36px', height: !matches ? '94px' : '36px' }} src={dataUser.sEmployeeID ? `http://hq-web-s13.pttplc.com/directory/photo/${dataUser.sEmployeeID}.jpg` : ""}></Avatar>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={9} md={9} sm={12} xs={12} style={{ textAlign: 'center', color: '#000000', marginTop: '-5px' }}>
          <Typography variant="body2" style={{ fontSize: '13px' }}>{dataUser.sName}</Typography>
          <Typography variant="subtitle2" style={{ fontSize: '11px' }}>{dataUser.sPosition}</Typography>
        </Grid>
      </Grid>


    </React.Fragment>
  );
}

export default UserInfo;
